<template>
	<div>
		<!-- begin breadcrumb -->
		<ol class="breadcrumb float-xl-right">
			<li class="breadcrumb-item active"><a href="javascript:;" @click="mostrarRegistrarChip=!mostrarRegistrarChip">Entrega Chips</a></li>
		</ol>
		<!-- end breadcrumb -->
		<!-- begin page-header -->
		<h1 class="page-header">Módulo Entrega Chips</h1>
		<!-- end page-header -->
		<!-- begin panel -->
		<!-- <panel title="Panel Title here">
			Panel Content Here
		</panel> -->
		<!-- end panel -->
		<!-- begin card -->
		<div class="card  border-0 ">
			<div class="card-body">
				<button v-show="nuevoEntregaChip==0" type="button" class="btn btn-warning "
					@click="nuevoEntregaChip=1;nuevo=true"> <i class="fa fa-plus"></i> Nueva Entrega de Chip </button>
				&nbsp;
				<button v-show="nuevoEntregaChip==1" type="button" class="btn btn-danger animated fadeIn"
					@click="nuevoEntregaChip=0"> <i class="fa fa-list"></i> Ver Entregas de Chips </button>
				 <button  id="registrarChip" type="button" v-b-modal.modalDialog class="btn btn-primary float-right ml-1">
					Registrar Detalle Por Chip </button> &nbsp; 
				<button id="resetearChip" type="button" v-b-modal.modalDialogReset class="btn btn-danger float-right">
					<i class="fas fa-spinner"></i> Reiniciar Chip </button>
			</div>
		</div>
		<!-- begin row -->
		<div class="row animated fadeIn" v-if="nuevoEntregaChip==0">
			<!-- begin col-12 -->
			<div class="col-xl-12 text-center">
				<h4 v-show="cargando"><i class="fa fa-spinner fa-spin"></i> Cargando...</h4>
				<registros :placeholder="'Buscar por DNI o Vendedor...'" v-if="!proceso" :ocultarEditar="true"
					:ocultarEliminar="true" :field="'Id'" :columns="columns2" @eliminar="confirmar($event)"
					@editar="nuevoEntregaChip=1;entregaChip={...$event};nuevo=false"
					:url="this.URL_BASE()+'entrega_chip_vendedor/search'" />
				<procesando v-if="proceso" />
			</div>
			<!-- end col-12 -->
		</div>
		<!-- end row -->
		<!-- begin row -->
		<div class="row animated fadeIn" v-if="nuevoEntregaChip==1">
			<!-- begin col-12 -->
			<div class="col-xl-12">
				<chip v-show="!proceso" @cancelar="nuevoEntregaChip=0" @actualizar="(actualizar($event))"
					@guardar="(guardar($event))" :registro="entregaChip" :nuevo="nuevo" />
				<procesando v-show="proceso" />
			</div>
			<!-- end col-12 -->

		</div>
		<!-- end row -->
		<!-- #modal-dialog -->
		<b-modal ref="modalDialog" id="modalDialog" cancel-variant="default"
			title="Ingrese los últimos 12 dígitos del CHIP">
			<!-- <input data-vv-name="chip" v-validate="'required|numeric'"  v-model="chip_detalle" type="text" placeholder="XXXXXX" maxlength="18" class="form-control font-weight-bold"> -->
			<autocompletado v-model="chip_detalle.chip" data-vv-name="chip" v-validate="'required'"
				:source="URL_BASE()+'detalle_ventas_chip/autocompletado/'" :results-property="'data'" :method="'post'"
				:resultsValue="'chip'" :results-display="'chip_completo'" :initialDisplay="chip_detalle.chip"
				:initialValue="chip_detalle.chip" @selected="seleccionando" data-vv-scope="validarChip" />

			<!-- <autocompletado v-model="chip_detalle.Id" data-vv-name="chip" v-validate="'required|numeric'" v-if="iniciar_autocompletado" :source="URL_BASE()+'detalle_ventas_chip/autocompletado/'"
                                :results-property="'data'" :method="'post'" :resultsValue="'id'"
                                :results-display="'nombre_comercial'" :initialDisplay="categoria.emisor"
                                :initialValue="categoria.emisor" @selected="opcionSeleccionada" /> -->

			<error :attribute_name="'chip'" :errors_form="errors" />

			<template #modal-footer>
				<b-button variant="primary" size="sm" class="float-right" @click="validarModalChip()">Ver
				</b-button>
				<b-button variant="secondary" size="sm" class="float-right" @click="$bvModal.hide('modalDialog')">
					Cancelar
				</b-button>


			</template>
		</b-modal>
		<!-- #modal-RESET CHIP -->
		<b-modal ref="modalDialogReset" id="modalDialogReset" cancel-variant="default" title="Reiniciar CHIP">
			<input data-vv-name="chip" data-vv-scope="Chip" v-validate="'required|numeric'" v-model="chipParaReset"
				type="text" placeholder="Ingrese el N° de Chip" maxlength="18" class="form-control font-weight-bold">

			<error :attribute_name="'chip'" :errors_form="errors" />

			<template #modal-footer>
				<b-button variant="primary" size="sm" class="float-right" @click="validarResetChip()">Reiniciar
				</b-button>
				<b-button variant="secondary" size="sm" class="float-right" @click="$bvModal.hide('modalDialogReset'),chipParaReset=''">
					Cancelar
				</b-button>


			</template>
		</b-modal>
	</div>
</template>
<script>
	import chip from '../components/compartidos/principales/EntregaChip'
	import registros from '../components/compartidos/Registros'
	import procesando from '../components/compartidos/Procesando'
	import axios from 'axios'
	import error from '../components/compartidos/Error'
	import autocompletado from '../components/compartidos/Autocomplete'
	export default {
		name: "EntregaChip",
		components: {
			chip,
			registros,
			procesando,
			error,
			autocompletado
		},
		created() {
			// this.loadItems() ;
			setTimeout(() => {
				this.iniciar_autocompletado = true;
			}, 100);
			setTimeout(() => {
				this.cargando = false;
			}, 1000);
			if (this.$route.params.modal == 'registrar') {
				// console.log("entra_");
				this.$bvModal.show("modalDialog")
				setTimeout(() => {
					document.getElementById("registrarChip").click();
				}, 600);
			}
		},
		data() {
			return {
				mostrarRegistrarChip:false,
				chipParaReset: "",
				cargando: true,
				iniciar_autocompletado: false,
				proceso: false,
				nuevo: true,
				entregaChip: null,
				nuevoEntregaChip: 0,
				chip_detalle: {
					Id: '',
					chip: ''
				},
				counter: 0,
				forms: [],
				detalles: [],
				totalRecords: 0,
				serverParams: {
					search: '',
					sort: {
						field: 'id',
						type: 'asc',
					},
					page: 1,
					perPage: 10
				},
				columns2: [{
						label: 'Chip Inicial',
						field: 'chip_inicial',
						width: '10%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'Chip Final',
						field: 'chip_final',
						width: '10%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'DNI - Vendedor',
						field: 'dni_vendedor',
						width: '10%',
						thClass: 'text-center',
						tdClass: 'text-center'
					},
					{
						label: 'Vendedor',
						field: 'vendedor',
						width: '30%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					{
						label: 'Cantidad',
						field: 'cantidad',
						width: '10%',
						thClass: 'text-center',
						tdClass: 'text-center'
					},
					{
						label: 'Detalle',
						rutaDetalle: '/entrega-detalle/chip/',
						field: 'dni_vendedor',
						width: '10%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},
					/*{
						label: 'Estado General',
						field: 'estado_general',
						width: '10%',
						thClass: 'text-nowrap',
						tdClass: 'text-nowrap'
					},*/

					{
						label: 'Creado el',
						field: 'fecha_registro',
						type: 'datetime',
						dateInputFormat: 'yyyy-MM-dd',
						dateOutputFormat: 'MMM do yy',
						width: '20%',
						tdClass: 'text-center text-nowrap',
						thClass: 'text-center text-nowrap'
					},

				]
			}
		},
		methods: {

			validarResetChip() {
				this.$validator.validateAll("Chip").then((result) => {
					if (result) {
						let a = confirm("¿Está seguro que desea proceder con el reinicio del chip?");
						if (a) {
							axios.post(this.URL_BASE() + "entrega_chip_vendedor/reiniciar_chip/"+this.chipParaReset).then(
								respuesta => {
									if (respuesta.data.msg == 'exito') {
										this.exito("Chip Reiniciado correctamente");
									}else{
										this.error("El Chip no fue reiniciado ");
									}
								}).catch((error)=> {
								console.log("er store" + error);
								this.error("El Chip no fue reiniciado ");
								
							});
						}
						// this.$router.push('/entrega-detalle/chips/'+this.chip_detalle.chip);
					}
				});
			},
			validarModalChip() {
				this.$validator.validateAll("validarChip").then((result) => {
					if (result) {
						this.$router.push('/entrega-detalle/chips/' + this.chip_detalle.chip);
					}
				});
			},
			actualizar(registro) {
				this.proceso = true;
				axios.put(this.URL_BASE() + "entrega_chip_vendedor/update/", registro).then(respuesta => {
					if (respuesta.data.msg == 'exito') {
						this.exito("Comisión registrada correctamente");
					}
					this.proceso = false;
				}).catch((error)=> {
					console.log("er store" + error);
				});
			},
			guardar(registro) {
				this.proceso = true;
				axios.post(this.URL_BASE() + "entrega_chip_vendedor/create/", registro).then(respuesta => {
					if (respuesta.data.msg == 'exito') {
						this.exito("Comisión actualizada correctamente");
					}
					this.proceso = false;
				}).catch((error)=> {
					console.log("er store" + error);
				});
			},
			confirmar(registros) {
				this.$swal({
					title: '¿Estás seguro?',
					text: '¡Los registros seleccionados se eliminarán!',
					type: 'warning',
					showCancelButton: true,
					buttonsStyling: false,
					confirmButtonText: 'Confirmar',
					cancelButtonText: 'Cancelar',
					confirmButtonClass: 'btn m-r-5 btn-warning',
					cancelButtonClass: 'btn btn-default',
				}).then((result) => {
					/* Read more about isConfirmed, isDenied below */
					if (result.value) {
						this.eliminar(registros);
						// this.$swal('Proceso confirmado', '', 'success')
						return true;
					} else if (result.dismiss) {
						return false;
						// Swal.fire('Changes are not saved', '', 'info')
					}
				})
			},
			eliminar(registros) {
				this.proceso = true;
				axios.post(this.URL_BASE() + "entrega_chip_vendedor/delete", registros).then(respuesta => {
					if (respuesta.data.msg == 'exito') {
						this.$swal('Proceso completado', '', 'success')
					}
					this.proceso = false;
				}).catch((error)=> {
					console.log("er store" + error);
				});
			},
			seleccionando(seleccion) {
				this.chip_detalle.chip = seleccion.chip;
			},
		},
	}
</script>